<template>
    <div class="d-flex justify-center">
        <v-card elevation="7" class="rounded-xl" max-width="450" width="390" min-width="350">
            <v-card flat color="white" height="178" class="rounded-b-0 pa-2 ">
                <div class="d-flex justify-center pt-4">
                    <v-img width="300" max-width="190" src="@/assets/Logo-bt-07.png" contain></v-img>
                </div>
            </v-card>
            <v-card-text>
                <v-avatar size="140" style="position:absolute; left: 32%; top: 105px;">
                    <v-img v-if="user.fotocarnet" :src="`data:image/jpeg;base64,${user.fotocarnet}`"
                        style=" border:4px solid #00a0df;" />
                    <v-img v-else src="@/assets/blank-user-profile.png" />
                </v-avatar>
            </v-card-text>
            <v-card-text class="my-2 px-5 mt-7">
                <div class="d-flex justify-center font-weight-bold black--text text-h5 text-center">LIC. {{ user.nombres
                    }}
                </div>
                <div class="d-flex justify-center font-weight-bold black--text text-h5 text-center">
                    {{ user.apellido }}
                </div>
                <div class="d-flex justify-center font-weight-bold primary--text text-subtitle-1">
                    {{ textSexo }}
                </div>
                <v-card-text class="d-flex flex-column">
                    <div class="font-weight-bold primary--text text-body-1">MP: {{ user.nroafi }} </div>
                    <div class="font-weight-bold black--text text-body-1">{{ user.tipdoc }}: {{ user.nrodoc }}
                    </div>
                </v-card-text>
                <v-card-text class="pt-0">
                    <div class="font-weight-regular black--text body-2">
                        {{ message }}
                        <span class="font-weight-bold primary--text">
                            {{ fechaExp }}
                        </span>
                    </div>
                </v-card-text>
                <v-row class="d-flex justify-center py-3">
                    <v-img max-width="300" src="@/assets/credencial/firmas.png"></v-img>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
    },
    data() {
        return {
            month: 0,
            date: '',
            message: 'La presente constancia habilita el uso de los convenios y tiene vencimiento el '
        }
    },
    methods: {
        ...mapActions('auth', ['generarCredencial']),

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatDni(dni) {
            var part = dni.toString().match(/\d{0,3}/g);
            return part.join('.')
        }
    },
    computed: {
        ...mapGetters('auth', ['user']),

        fechaExp() {
            return this.formatDate(this.user.vencimientocredencialactivo)
        },
        textSexo() {
            switch (this.user.sexo) {
                case 'M':
                    return "Afiliado Activo"
                case 'F':
                    return "Afiliada Activa"
                case 'X':
                    return "Afiliadx Activx"
                default:
                    return "Afiliada/o Activa/o"
            }
        }
    },
}
</script>


<style>
.rounded-card {
    /* You can adjust the value to control the roundness of the corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Optional: Add shadow for a more prominent card effect */
}
</style>